export * from './property-text.component';
